import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import navigoServices from "../../services/NavigoServices";
import { sortServicesByPriority } from "./utils/serviceOrder";
import moment from "moment";
import { getStringSlot } from "./utilityFunctions";
import { errorMessageHandler } from "../../utils/helperMethods";

const initialState = {
  services: [],
  appointments: [],
  plans: [],
  servicePlan: [],
  providers: [],
  options: [],
  reasons: [],
  serviceBothplan: {},
  config: {},
  ui: {
    currScreen: 1,
    currentServices: {},
    currentAppointment: {},
    isReschedule: false,
    isForFamily: false,
    loadingSlots: false,
    appointmentDate: null,
    timeSlot: null,
    slots: [],
    dateArr: [],
    dateSelected: -1,
    sltInd: -1,
    callReschedule: false,
    currentFamilyMemberCount: 0,
    cancelAppointmentId: -1,
    upcomingAppointments: [],
    pastAppointments: [],
    addressSelected: null,
    familyMemberSelected: 0,
    familyMemberSelectedData: {},
    callHandleAvailNow: false,
    paymentLoaderOrderId: "",
    openZylaPay: false,
    openBookAfterPayment: false,
    loadedAppointments: false,
    lodedServices: false,
    fetchingAppointments: false,
    fetchingServices: false,
    loadedPlans: false,
    fetchingPlans: false,
    vendorId: "",
    vendorCode: "",
    isErrorPositive: false,
    serviceTypeId: "",
    isUserSelectedFamily: false,
    loadingProvider: false,
    currentSelectedService: null,
    currentSelectedPlan: null,
    selectedBookingMode: "",
    selectedBookingProvider: null,
    selectedPlanId: null,
    selectedPlanName: null,
    isCmpBooking: false,
    // Second Medical Opinion (pageType 8) reordered flow: discriminator + the
    // reason/contact/files collected up-front on the ReasonScreen and consumed
    // at the final slot-confirmation step. Lives in `ui` (persist-blacklisted)
    // so the raw File objects never get serialized.
    isSmoBooking: false,
    smoDraft: null,
    // Files (in-memory) to upload + map to a PAID appointment after payment
    // succeeds. Not persisted (ui is persist-blacklisted); consumed in
    // BookAfterPayment once the v1 zpay status comes back successful.
    pendingPaidDocs: null,
    pickedLocation: null,
    centreFilter: null,
    locationFilterStates: [],
  },
};
export const getAllServices = createAsyncThunk(
  "navigo/services",
  async (data, { rejectWithValue }) => {
    const { id, serviceType } = data;
    try {
      const response = await navigoServices.getServiceByPatientId(
        id,
        serviceType,
      );

      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getAllPlans = createAsyncThunk(
  "navigo/plans",
  async (data, { rejectWithValue }) => {
    const { id } = data;
    try {
      const response = await navigoServices.getPlansByPatientId(id);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getPlanService = createAsyncThunk(
  "navigo/planService",
  async (body, { rejectWithValue }) => {
    try {
      const response = await navigoServices.getPlanService(body);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
export const getConsultation = createAsyncThunk(
  "navigo/getConsultation",
  async (body, { rejectWithValue }) => {
    try {
      const response = await navigoServices.getPlanService(body);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getHealthPlan = createAsyncThunk(
  "navigo/getHealthPlan",
  async (body, { rejectWithValue }) => {
    try {
      const response = await navigoServices.getPlanService(body);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getProvider = createAsyncThunk(
  "navigo/provider",
  async (body, { rejectWithValue }) => {
    try {
      const response = await navigoServices.getProvider(body);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getProvidersByFilter = createAsyncThunk(
  "navigo/providersByFilter",
  async (body, { rejectWithValue }) => {
    try {
      const response = await navigoServices.getAllTimeSlot(body);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getOptions = createAsyncThunk(
  "navigo/options",
  async (body, { rejectWithValue }) => {
    try {
      const response = await navigoServices.getOptions(body);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getReasons = createAsyncThunk(
  "navigo/reason",
  async ({ _, rejectWithValue }) => {
    console.log("inside function");
    try {
      const response = await navigoServices.getReason();
      console.log("inside", response);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const checkConfig = createAsyncThunk(
  "navigo/config",
  async ({ patientId, planId, program }, { rejectWithValue }) => {
    try {
      const response = await navigoServices.checkConfig(
        patientId,
        planId,
        program,
      );
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getAllAppointments = createAsyncThunk();
// "navigo/appointments",
// async (data, { rejectWithValue }) => {
//   try {
//     const { id, serviceType } = data;
//     const response = await navigoServices.getAllAppointmentsByPatientId(
//       id,
//       serviceType
//     );
//     return response;
//   } catch (err) {
//     return rejectWithValue(err);
//   }
// }

export const cancelAppointement = createAsyncThunk(
  "navigo/cancel",
  async (data, { rejectWithValue }) => {
    try {
      const response = await navigoServices.updateAppointmentStatus(data);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const rescheduleAppointments = createAsyncThunk(
  "navigo/reschedule",
  async (data, { rejectWithValue }) => {
    try {
      const response = await navigoServices.rescheduleAppointments(data);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const rescheduleLabtestAppointments = createAsyncThunk(
  "navigo/resheduleLabtest",
  async (data, { rejectWithValue }) => {
    try {
      const response = await navigoServices.cancelAndRescheduleLabAppointments(
        data,
      );
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const createAppointments = createAsyncThunk(
  "navigo/create",
  async (data, { rejectWithValue }) => {
    console.log("inside call", data);
    try {
      const response = await navigoServices.createAppointment(data);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const uploadDocuments = createAsyncThunk(
  "navigo/documents",
  async (data, { rejectWithValue }) => {
    try {
      const response = await navigoServices.uploadDocuments(data);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const documentMapping = createAsyncThunk(
  "navigo/documentMapping",
  async (data, { rejectWithValue }) => {
    try {
      const response = await navigoServices.documentMapping(data);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getAllTimeSlots = createAsyncThunk(
  "navigo/rcSlots",
  async (arg, { rejectWithValue }) => {
    try {
      const { data } = arg;
      const response = await navigoServices.getAllTimeSlots(data);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getNavigoServicesSlots = createAsyncThunk(
  "navigo/slots",
  async (arg, { rejectWithValue }) => {
    try {
      const { serviceId, date } = arg.data;
      const response = await navigoServices.getTimeSlots(serviceId, date);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

const navigoSlice = createSlice({
  name: "navigo",
  initialState: initialState,
  reducers: {
    handleError: (state, actions) => {
      return {
        ...state,
      };
    },
    updateCurrentScreen: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          currScreen: actions.payload,
        },
      };
    },
    navigoShowError: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          error: true,
          errorMsg: actions.payload.msg,
          isErrorPositive: actions.payload.isPositive,
          openDrawer: false,
          openZylaPay: false,
          paymentLoaderOrderId: "",
          drawerType: 0,
          loadingSlots: false,
        },
      };
    },
    navigoClearError: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          error: false,
          errorMsg: "",
          isErrorPositive: false,
        },
      };
    },
    setStateFromPayload: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          ...actions.payload,
        },
      };
    },
    // Drop just the fetched services, keeping plans and the loaded/fetching
    // gates intact — clearAppointmentAndServices also wipes `plans` and resets
    // loadedPlans, which would restart the whole plans fetch.
    clearServicePlan: (state) => {
      return { ...state, servicePlan: [] };
    },
    setProvidersList: (state, actions) => {
      return {
        ...state,
        providers: [...(actions.payload || [])],
      };
    },
    openFamilyProfileReducer: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          openFamilyProfile: true,
          familyProfileData: actions.payload,
          openAddFamily: false,
        },
      };
    },
    setSelectedPlan: (state, action) => {
      state.ui.selectedPlanId = action.payload.planId;
      state.ui.selectedPlanName = action.payload.planName;
    },
    clearAppointmentAndServices: (state, actions) => {
      return {
        ...state,
        plans: [],
        servicePlan: [],
        serviceBothplan: {},
        ui: {
          ...state.ui,
          // currScreen: 1,
          loadedAppointments: false,
          fetchingAppointments: false,
          loadedServices: false,
          fetchingServices: false,
          loadedPlans: false,
          fetchingPlans: false,
          // Reset the SMO flow flags on every /navigo entry so a stale value
          // from a previous SMO booking can never leak into another flow.
          isSmoBooking: false,
          smoDraft: null,
          pendingPaidDocs: null,
          serviceTypeId: actions.payload.serviceTypeId
            ? actions.payload.serviceTypeId
            : "",
        },
      };
    },
  },
  extraReducers: {
    // [getAllServices.pending]: (state, actions) => {
    //   return { ...state, ui: { ...state.ui, fetchingServices: true } };
    // },
    // [getAllServices.fulfilled]: (state, actions) => {
    //   return {
    //     ...state,

    //     services: [...actions.payload.data.services],
    //     ui: {
    //       ...state.ui,
    //       loadedServices: true,
    //     },
    //   };
    // },
    // [getAllServices.rejected]: (state, actions) => {
    //   return {
    //     ...state,
    //     ui: {
    //       ...state.ui,
    //       error: true,
    //       errorMsg: "Error while fetching services.",
    //     },
    //   };
    // },
    [getAllPlans.pending]: (state, actions) => {
      // loadedPlans doubles as the "already requested" gate in newIndex, so it
      // is set here, on pending. fetchingPlans is the actual in-flight flag —
      // screens need it to tell "request running" from "patient has no plans",
      // which both look like an empty plans array.
      return {
        ...state,
        ui: { ...state.ui, loadedPlans: true, fetchingPlans: true },
      };
    },
    [getAllPlans.fulfilled]: (state, actions) => {
      return {
        ...state,

        plans: [...actions.payload.data],
        ui: {
          ...state.ui,
          loadedPlans: true,
          fetchingPlans: false,
        },
      };
    },
    [getAllPlans.rejected]: (state, actions) => {
      // This handler must exist. `pending` sets loadedPlans AND fetchingPlans
      // to true, and the screens read `fetchingPlans` as "a request is in
      // flight". With no rejected case a failed plans call left it true
      // forever: every navigo first-section spun its loader with no error and
      // no retry.
      //
      // Clear fetchingPlans (ends the spinner, surfaces the error) but LEAVE
      // loadedPlans true. It doubles as newIndex's "already requested" gate:
      // `if (!loadedPlans && !fetchingPlans) dispatch(getAllPlans(...))` runs
      // on an effect whose deps include both flags, so clearing it here would
      // re-dispatch on every rejection and spin the request forever against a
      // failing API. A retry belongs behind the error banner, not in a loop.
      return {
        ...state,
        ui: {
          ...state.ui,
          loadedPlans: true,
          fetchingPlans: false,
          error: true,
          errorMsg: "Error while fetching plans.",
        },
      };
    },
    [getPlanService.pending]: (state, actions) => {
      return { ...state, ui: { ...state.ui } };
    },
    [getPlanService.fulfilled]: (state, actions) => {
      return {
        ...state,

        servicePlan: sortServicesByPriority(actions.payload.data.services),
        ui: {
          ...state.ui,
        },
      };
    },
    // [getPlanService.rejected]: (state, actions) => {
    //   return {
    //     ...state,
    //     ui: {
    //       ...state.ui,
    //       error: true,
    //     },
    //   };
    // },
    [getConsultation.pending]: (state, actions) => {
      return state;
    },
    [getConsultation.fulfilled]: (state, action) => {
      state.serviceBothplan = {
        ...state.serviceBothplan,
        consultation: action.payload.data.services,
      };
    },

    [getHealthPlan.fulfilled]: (state, action) => {
      state.serviceBothplan = {
        ...state.serviceBothplan,
        healthplan: action.payload.data.services,
      };
    },

    // [getConsultation.rejected]: (state) => {
    //   return {
    //     ...state,
    //     ui: {
    //       ...state.ui,
    //       error: true,
    //     },
    //   };
    // },

    // [getHealthPlan.rejected]: (state) => {
    //   return {
    //     ...state,
    //     ui: {
    //       ...state.ui,
    //       error: true,
    //     },
    //   };
    // },
    [getProvider.pending]: (state, actions) => {
      return { ...state, ui: { ...state.ui, loadingProvider: true } };
    },
    [getProvider.fulfilled]: (state, actions) => {
      return {
        ...state,

        providers: [...(actions.payload.data.providers || [])],
        ui: {
          ...state.ui,
          loadingProvider: false,
        },
      };
    },
    [getProvider.rejected]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          loadingProvider: false,
        },
      };
    },
    [getProvidersByFilter.pending]: (state, actions) => {
      return { ...state, ui: { ...state.ui, loadingProvider: true } };
    },
    [getProvidersByFilter.fulfilled]: (state, actions) => {
      const data = actions.payload?.data;
      const list = Array.isArray(data?.providers)
        ? data.providers
        : Array.isArray(data)
          ? data
          : [];
      return {
        ...state,
        providers: [...list],
        ui: {
          ...state.ui,
          loadingProvider: false,
        },
      };
    },
    [getProvidersByFilter.rejected]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          loadingProvider: false,
        },
      };
    },
    [checkConfig.fulfilled]: (state, actions) => {
      return {
        ...state,

        config: { ...actions.payload.data },
        ui: {
          ...state.ui,
        },
      };
    },
    [getOptions.pending]: (state, actions) => {
      return { ...state, ui: { ...state.ui } };
    },
    [getOptions.fulfilled]: (state, actions) => {
      return {
        ...state,

        options: [...(actions.payload.data.providers || [])],
        ui: {
          ...state.ui,
        },
      };
    },
    [getOptions.rejected]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          error: true,
        },
      };
    },
    [getReasons.pending]: (state, actions) => {
      return { ...state, ui: { ...state.ui } };
    },
    [getReasons.fulfilled]: (state, actions) => {
      return {
        ...state,

        reasons: [...actions.payload.data],
        ui: {
          ...state.ui,
        },
      };
    },
    [getReasons.rejected]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          error: true,
        },
      };
    },
    [getAllAppointments.pending]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          fetchingAppointments: true,
        },
      };
    },
    [getAllAppointments.fulfilled]: (state, actions) => {
      return {
        ...state,
        appointments: { ...actions.payload.data },
        ui: {
          ...state.ui,
          loadedAppointments: true,
        },
      };
    },
    // [getAllAppointments.rejected]: (state, actions) => {
    //   return {
    //     ...state,
    //     ui: {
    //       ...state.ui,
    //       error: true,
    //     },
    //   };
    // },
    [cancelAppointement.pending]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          openDrawer: true,
        },
      };
    },
    [cancelAppointement.fulfilled]: (state, actions) => {
      const appointId = actions.meta.arg.appointmentID;
      let cancelledAppointment = {};
      let filteredList = state.ui.upcomingAppointments.filter((appoint) => {
        if (appointId === appoint.appointment.ID) {
          cancelledAppointment = { ...appoint };
        }
        return appointId !== appoint.appointment.ID;
      });
      let pastAppoint = [];
      if (state.ui.pastAppointments && state.ui.pastAppointments.length > 0) {
        pastAppoint = [
          { ...cancelledAppointment },
          ...state.ui.pastAppointments,
        ];
      } else {
        pastAppoint = [{ ...cancelledAppointment }];
      }
      return {
        ...state,
        ui: {
          ...state.ui,
          openDrawer: false,
          drawerType: 0,
          upcomingAppointments: filteredList,
          pastAppointments: pastAppoint,
          cancelAppointmentId: -1,
        },
      };
    },
    [cancelAppointement.rejected]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          error: true,
          errorMsg: "Something went wrong.",
          openDrawer: false,
          drawerType: 0,
        },
      };
    },
    [rescheduleAppointments.pending]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          openDrawer: true,
        },
      };
    },
    [rescheduleAppointments.fulfilled]: (state, actions) => {
      const res = actions.payload.data;
      let newUpcomingAppointments = state.ui.upcomingAppointments.map(
        (appoint) => {
          if (
            appoint.appointment.ID ===
            state.ui.currentAppointment.appointment.ID
          ) {
            return {
              ...appoint,
              appointment: {
                ...appoint.appointment,
                appointmentDate: moment(res.appointmentDate).format(
                  "DD MMM, YYYY",
                ),
                timeSlot: getStringSlot(res.timeSlot),
                status: res.status,
              },
            };
          }
          return { ...appoint };
        },
      );
      return {
        ...state,
        ui: {
          ...state.ui,
          openDrawer: false,
          drawerType: 0,
          currScreen: 1,
          upcomingAppointments: newUpcomingAppointments,
          isReschedule: false,
          callReschedule: false,
        },
      };
    },
    [rescheduleAppointments.rejected]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          error: true,
          errorMsg: "Reschedule failed.",
          openDrawer: false,
          drawerType: 0,
          callReschedule: false,
        },
      };
    },
    [rescheduleLabtestAppointments.pending]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          openDrawer: true,
        },
      };
    },
    [rescheduleLabtestAppointments.fulfilled]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          callReschedule: true,
        },
      };
    },
    [rescheduleLabtestAppointments.rejected]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          openDrawer: false,
          drawerType: 0,
          error: true,
          errorMsg: "Reschedule failed.",
        },
      };
    },
    [createAppointments.pending]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          openDrawer: true,
          drawerType: 10,
        },
      };
    },
    [createAppointments.rejected]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          openDrawer: false,
          drawerType: 0,
          error: true,
          errorMsg: errorMessageHandler(
            actions.payload.response.data,
            "Couldn't create appointment.",
          ),
        },
      };
    },
    [getAllTimeSlots.pending]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          loadingSlots: true,
          dateSelected: actions.meta.arg.dateSelected,
          appointmentDate: actions.meta.arg.appointmentDate,
        },
      };
    },
    [getAllTimeSlots.fulfilled]: (state, actions) => {
      const res = actions.payload.data;
      let allSlots = [];
      if (res && res.slots && res.slots.length > 0) {
        const { serviceProviderId } = res;
        allSlots = res.slots.map((slt, index) => {
          return {
            id: slt.key,
            time: getStringSlot(slt.value),
            serviceProviderId,
          };
        });
      }

      return {
        ...state,
        ui: {
          ...state.ui,
          slots: allSlots,
          timeSlot: null,
          loadingSlots: false,
          sltInd: -1,
          vendorId: res.vendorId,
          vendorCode: res.vendorName,
        },
      };
    },
    [getAllTimeSlots.rejected]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          slots: [],
          loadingSlots: false,
          error: true,
          errorMsg: "error while fetching slots.",
        },
      };
    },
    [getNavigoServicesSlots.pending]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          loadingSlots: true,
          dateSelected: actions.meta.arg.dateSelected,
          appointmentDate: actions.meta.arg.appointmentDate,
        },
      };
    },
    [getNavigoServicesSlots.fulfilled]: (state, actions) => {
      const res = actions.payload.data;
      let allSlots = [];
      if (res && res.slot && res.slot.length > 0) {
        allSlots = res.slot.map((slt, index) => {
          return { id: index, time: getStringSlot(slt) };
        });
      }
      return {
        ...state,
        ui: {
          ...state.ui,
          slots: allSlots,
          timeSlot: null,
          loadingSlots: false,
          sltInd: -1,
        },
      };
    },
    [getNavigoServicesSlots.rejected]: (state, actions) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          loadingSlots: false,
          error: true,
          errorMsg: "No slot available for selected date.",
        },
      };
    },
  },
});

export const {
  updateCurrentScreen,
  navigoShowError,
  navigoClearError,
  setStateFromPayload,
  setProvidersList,
  clearAppointmentAndServices,
  clearServicePlan,
  setSelectedPlan,
} = navigoSlice.actions;
export default navigoSlice.reducer;
